export default (t) => ({
  element: 'bpmn:ServiceTask',
  service: 'telegram',
  title: t('script.controlls.telegram.title'),
  helplink: '',
  group: 'communication',
  class: 'other',
  color: '#60a5c0',
  border: 2,
  icon: 'anticon-icon communication-47',
  icon_scale: 0.9,
  offset_x: -6,
  offset_y: -12,
  toolbar_offset_x: -6,
  toolbar_offset_y: -12,
  icon_rotate: 0,
  priority: 10,
  config: [
    {
      id: 'commonSection',
      name: t('script.common.general'),
      type: 'group',
    },
    {
      id: 'name',
      name: t('script.common.title'),
      type: 'text',
      readOnly: false,
      config: {
        defaultEmptyValue: t('script.controlls.telegram.title'),
        type: 'text',
        valueType: 'const',
        map: 'input',
      },
    },
    {
      id: 'description',
      name: t('script.common.description'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        valueType: 'const',
        map: 'input',
      },
    },
    {
      id: 'section_connection',
      name: t('script.controlls.telegram.sectionConnection'),
      type: 'group',
    },
    {
      id: 'service',
      name: t('script.controlls.telegram.service'),
      type: 'object',
      readOnly: false,
      config: {
        catalogId: '$authServices',
        multiselect: false,
        enableCreate: true,
        enableSelect: true,
        view: 'list',
        map: 'input',
      },
    },
    {
      id: 'connectionType',
      name: t('script.controlls.telegram.connectionType'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          {
            id: 'client',
            name: t('script.controlls.telegram.client'),
            color: 'DFE0E0',
          },
          {
            id: 'bot',
            name: t('script.controlls.telegram.bot'),
            color: 'DFE0E0',
          },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['client'],
        map: 'input',
      },
    },
    {
      id: 'section_parameters',
      name: t('script.controlls.telegram.sectionParameters'),
      type: 'group',
    },
    {
      id: 'action',
      name: t('script.controlls.telegram.action'),
      type: 'radiobutton',
      readOnly: false,
      config: {
        items: [
          {
            id: 'sendMessage',
            name: t('script.controlls.telegram.sendMessage'),
          },
          {
            id: 'sendLocation',
            name: t('script.controlls.telegram.sendLocation'),
          },
          {
            id: 'sendContact',
            name: t('script.controlls.telegram.sendContact'),
          },
          {
            id: 'sendReaction',
            name: t('script.controlls.telegram.sendReaction'),
          },
          {
            id: 'forwardMessage',
            name: t('script.controlls.telegram.forwardMessage'),
          },
          {
            id: 'editMessage',
            name: t('script.controlls.telegram.editMessage'),
          },
          {
            id: 'deleteMessage',
            name: t('script.controlls.telegram.deleteMessage'),
          },
          {
            id: 'getDialogs',
            name: t('script.controlls.telegram.getDialogs'),
          },
          {
            id: 'getMessages',
            name: t('script.controlls.telegram.getMessages'),
          },
          {
            id: 'getProfile',
            name: t('script.controlls.telegram.getProfile'),
          },
        ],
        type: 'select',
        map: 'input',
        defaultEmptyValue: 'sendMessage',
      },
    },
    {
      id: 'isNotSupported',
      name: t('script.controlls.telegram.isNotSupportedAction'),
      type: 'text',
      readOnly: false,
      apiOnly: true,
      config: {
        defaultEmptyValue: t('script.controlls.telegram.isNotSupportedActionValue'),
        type: 'text',
        valueType: 'const',
        map: 'input',
      },
      visible: {
        $or: [
          {
            connectionType: {
              $in: ['bot'],
            },
            action: {
              $in: ['sendReaction', 'getDialogs'],
            },
          },
        ],
      },
    },
    {
      id: 'dialog',
      name: t('script.controlls.telegram.dialog'),
      hint: t('script.controlls.telegram.dialogHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        $or: [
          {
            connectionType: {
              $include: 'client',
            },
            action: {
              $in: [
                'sendMessage',
                'sendLocation',
                'sendContact',
                'sendReaction',
                'forwardMessage',
                'editMessage',
                'deleteMessage',
                'getMessages',
                'getProfile',
              ],
            },
          },
          {
            connectionType: {
              $include: 'bot',
            },
            action: {
              $in: [
                'sendMessage',
                'sendLocation',
                'sendContact',
                'forwardMessage',
                'editMessage',
                'deleteMessage',
                'getProfile',
              ],
            },
          },
        ],
      },
    },
    {
      id: 'outputDialog',
      name: t('script.controlls.telegram.outputDialog'),
      hint: t('script.controlls.telegram.dialogHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['forwardMessage'],
        },
      },
    },
    {
      id: 'messageId',
      name: t('script.controlls.telegram.messageId'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        $or: [
          {
            connectionType: {
              $include: 'client',
            },
            action: {
              $in: ['sendReaction', 'forwardMessage', 'editMessage', 'deleteMessage'],
            },
          },
          {
            connectionType: {
              $include: 'bot',
            },
            action: {
              $in: ['editMessage', 'deleteMessage', 'forwardMessage'],
            },
          },
        ],
      },
    },
    {
      id: 'location',
      name: t('script.controlls.telegram.location'),
      hint: t('script.controlls.telegram.locationHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $include: 'sendLocation',
        },
      },
    },
    {
      id: 'contact',
      name: t('script.controlls.telegram.contact'),
      hint: t('script.controlls.telegram.contactHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $include: 'sendContact',
        },
      },
    },
    {
      id: 'text',
      name: t('script.controlls.telegram.text'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['sendMessage', 'editMessage'],
        },
      },
    },
    {
      id: 'parseMode',
      name: t('script.controlls.telegram.parseMode'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          {
            id: 'md',
            name: 'Markdown',
            color: 'DFE0E0',
          },
          {
            id: 'html',
            name: 'HTML',
            color: 'DFE0E0',
          },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['md'],
        map: 'input',
      },
      visible: {
        action: {
          $in: ['sendMessage', 'editMessage'],
        },
      },
    },
    {
      id: 'attachments',
      name: t('script.controlls.telegram.attachments'),
      hint: t('script.controlls.telegram.attachmentsHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'multiline',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['sendMessage'],
        },
      },
    },
    {
      id: 'attachmentsView',
      name: t('script.controlls.telegram.attachmentsView'),
      hint: t('script.controlls.telegram.attachmentsViewHint'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          {
            id: 'media',
            name: 'Медиа',
            color: 'DFE0E0',
          },
          {
            id: 'document',
            name: 'Документы',
            color: 'DFE0E0',
          },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['media'],
        map: 'input',
      },
      visible: {
        action: {
          $include: 'sendMessage',
        },
        connectionType: {
          $in: ['client'],
        },
      },
    },
    {
      id: 'buttons',
      name: t('script.controlls.telegram.buttons'),
      hint: t('script.controlls.telegram.buttonsHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        connectionType: {
          $in: ['bot'],
        },
        action: {
          $in: ['sendMessage', 'editMessage'],
        },
      },
    },
    {
      id: 'deleteType',
      name: t('script.controlls.telegram.deleteType'),
      type: 'switch',
      readOnly: false,
      config: {
        defaultEmptyValue: true,
      },
      visible: {
        action: {
          $in: ['deleteMessage'],
        },
        connectionType: {
          $in: ['client'],
        },
      },
    },
    {
      id: 'reactions',
      name: t('script.controlls.telegram.reactions'),
      hint: t('script.controlls.telegram.reactionsHint'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'multiline',
        map: 'input',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $include: 'sendReaction',
        },
        connectionType: {
          $in: ['client'],
        },
      },
    },
    // {
    //   id: 'additional_section',
    //   name: t('script.controlls.telegram.additionalSection'),
    //   type: 'group',
    //   visible: {
    //     action: {
    //       $in: ['sendMessage', 'sendLocation', 'sendContact', 'forwardMessage'],
    //     },
    //   },
    // },
    {
      id: 'isDropAuthor',
      name: t('script.controlls.telegram.isDropAuthor'),
      type: 'switch',
      readOnly: false,
      config: {
        defaultEmptyValue: false,
      },
      visible: {
        action: {
          $in: ['forwardMessage'],
        },
      },
    },
    {
      id: 'isReply',
      name: t('script.controlls.telegram.isReply'),
      type: 'switch',
      readOnly: false,
      config: {
        defaultEmptyValue: false,
      },
      visible: {
        action: {
          $in: ['sendMessage', 'sendLocation', 'sendContact'],
        },
      },
    },
    {
      id: 'replyMessageId',
      name: t('script.controlls.telegram.replyMessageId'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        isReply: {
          $include: true,
        },
      },
    },
    {
      id: 'isScheduled',
      name: t('script.controlls.telegram.isScheduled'),
      type: 'switch',
      readOnly: false,
      config: {
        defaultEmptyValue: false,
      },
      visible: {
        action: {
          $in: ['sendMessage', 'sendLocation', 'sendContact', 'forwardMessage'],
        },
        connectionType: {
          $in: ['client'],
        },
      },
    },
    {
      id: 'scheduledDate',
      name: t('script.controlls.telegram.scheduledDate'),
      hint: t('script.controlls.telegram.dateHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        isScheduled: {
          $include: true,
        },
      },
    },
    {
      id: 'isSilent',
      name: t('script.controlls.telegram.isSilent'),
      type: 'switch',
      readOnly: false,
      config: {
        defaultEmptyValue: false,
      },
      visible: {
        action: {
          $in: ['sendMessage', 'sendLocation', 'sendContact', 'forwardMessage'],
        },
      },
    },
    {
      id: 'limit',
      name: t('script.controlls.telegram.limit'),
      hint: t('script.controlls.telegram.limitHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        $or: [
          {
            action: {
              $in: ['getMessages', 'getDialogs'],
            },
            connectionType: {
              $include: 'client',
            },
          },
          {
            action: {
              $in: ['getMessages'],
            },
            connectionType: {
              $include: 'bot',
            },
          },
        ],
      },
    },
    {
      id: 'offsetDate',
      name: t('script.controlls.telegram.offsetDate'),
      hint: t('script.controlls.telegram.offsetDateHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['getDialogs'],
        },
        connectionType: {
          $include: 'client',
        },
      },
    },
    {
      id: 'offsetId',
      name: t('script.controlls.telegram.offsetId'),
      hint: t('script.controlls.telegram.offsetIdHint'),
      type: 'text',
      readOnly: false,
      config: {
        map: 'input',
        type: 'text',
        theme: 'script',
        placeholder: t('script.common.valueExpression'),
      },
      visible: {
        action: {
          $in: ['getMessages'],
        },
      },
    },
    {
      id: 'type',
      name: t('script.controlls.telegram.type'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          {
            id: 'unread',
            name: t('script.controlls.telegram.unread'),
            color: 'DFE0E0',
          },
          {
            id: 'all',
            name: t('script.controlls.telegram.all'),
            color: 'DFE0E0',
          },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['unread'],
        map: 'input',
      },
      visible: {
        action: {
          $in: ['getDialogs', 'getMessages'],
        },
        connectionType: {
          $include: 'client',
        },
      },
    },
    {
      id: 'sortType',
      name: 'Сортировка',
      type: 'dropdown',
      readOnly: false,
      config: {
        defaultEmptyValue: ['asc'],
        items: [
          {
            id: 'asc',
            name: t('script.controlls.telegram.sortAsc'),
            color: 'E7E9ED',
          },
          {
            id: 'desc',
            name: t('script.controlls.telegram.sortDesc'),
            color: 'E7E9ED',
          },
        ],
        map: 'input',
      },
      visible: {
        action: {
          $in: ['getMessages'],
        },
        connectionType: {
          $include: 'client',
        },
      },
    },
    {
      id: 'markRead',
      name: t('script.controlls.telegram.markRead'),
      type: 'switch',
      readOnly: false,
      config: {
        defaultEmptyValue: true,
      },
      visible: {
        action: {
          $in: ['getMessages'],
        },
        connectionType: {
          $include: 'client',
        },
      },
    },
    {
      id: 'attachmentsType',
      name: t('script.controlls.telegram.attachmentsType'),
      type: 'dropdown',
      readOnly: false,
      config: {
        items: [
          {
            id: 'skip',
            name: t('script.controlls.telegram.skip'),
            color: 'DFE0E0',
          },
          {
            id: 'links',
            name: t('script.controlls.telegram.links'),
            color: 'DFE0E0',
          },
        ],
        defaultValue: true,
        multiselect: false,
        defaultEmptyValue: ['skip'],
        map: 'input',
      },
      visible: {
        action: {
          $in: ['getMessages', 'getUpdates'],
        },
        connectionType: {
          $include: 'client',
        },
      },
    },
    {
      id: 'section_output',
      name: t('script.common.result'),
      type: 'group',
      visible: {
        $or: [
          {
            connectionType: {
              $include: 'client',
            },
          },
          {
            connectionType: {
              $include: 'bot',
            },
            action: {
              $in: [
                'sendMessage',
                'sendLocation',
                'sendContact',
                'forwardMessage',
                'editMessage',
                'deleteMessage',
                'getProfile',
                'getMessages',
              ],
            },
          },
        ],
      },
    },
    {
      id: 'output_body',
      name: t('script.controlls.telegram.saveResult'),
      type: 'text',
      readOnly: false,
      config: {
        type: 'text',
        map: 'output',
        placeholder: t('script.common.variableName'),
      },
    },
  ],
  exits: [],
});
